import {ModuleComponent} from "../../js/module-component";
import Swiper from 'swiper/bundle';

export class ModMultiSlide extends ModuleComponent{
    ready() {
        super.ready();

        this.swiper = new Swiper(this.$root.find(`.swiper-container`).get(0),{
            direction: `horizontal`,
            slidesPerView: 1,
            speed: 800,
            loop: this.$root.find(`.swiper-slide`).length>1,
            centeredSlides: false,
            grabCursor: false,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: this.$root.find(`.swiper-pagination`).get(0),
                clickable: true,
                pauseOnMouseEnter: true
            },
            autoplay: {
                delay: 7000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            },
            effect: `slide`,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            mousewheel: {
                enabled: false
            }
        });

        this.$root.find(`.swiper-container`).mouseenter(() => {
            this.swiper.autoplay.stop();
        }).mouseleave(() => {
            this.swiper.autoplay.start();
        });
    }
}